module.exports = __webpack_public_path__ + "img/commentRate_1.d491d60e.png";